import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomTextInput from "../../../../components/CustomTextInput";
import { DocumentTypeYurticiEnum } from "../../../../models/common/Enums";
import { ConstantService } from "../../../../services/ConstantService";

interface Props {
    shippingAndDocumentInformationRef: any
    documentNo: string | undefined
    setDocumentNo: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedDocumentType: CustomSingleSelectModel | undefined
    setSelectedDocumentType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedReceivingType: CustomSingleSelectModel | undefined
    setSelectedReceivingType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeliveringType: CustomSingleSelectModel | undefined
    setSelectedDeliveringType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedShippingRegion: CustomSingleSelectModel | undefined
    setSelectedShippingRegion: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    despatchNo: string | undefined
    setDespatchNo: React.Dispatch<React.SetStateAction<string | undefined>>
    consigmentNo: string | undefined
    setConsigmentNo: React.Dispatch<React.SetStateAction<string | undefined>>
}

const ShippingAndDocumentInformation = ({
    shippingAndDocumentInformationRef,
    documentNo,
    setDocumentNo,
    selectedDocumentType,
    setSelectedDocumentType,
    selectedReceivingType,
    setSelectedReceivingType,
    selectedDeliveringType,
    setSelectedDeliveringType,
    selectedShippingRegion,
    setSelectedShippingRegion,
    despatchNo,
    setDespatchNo,
    consigmentNo,
    setConsigmentNo,
}: Props) => {
    return (
        <div className='containerPart' ref={shippingAndDocumentInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Gönderi ve Evrak Bilgileri</h4>

                    <div className="row">
                        <div className="col-md-4">
                            <CustomTextInput labelText="Belge No" isLabelRequired value={documentNo} setValue={setDocumentNo} isDisabled />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Belge Tipi"
                                isLabelRequired
                                selectedValue={selectedDocumentType}
                                onChange={setSelectedDocumentType}
                                onMenuOpen={() => ConstantService.getConstantList('DOCUMENT_TYPE_YURTICI')}
                                labelName='value'
                                valueName="constantId"
                                additionalValue1Name="additionalValue1"
                                disabled
                            />
                        </div>

                        {/* <div className="col-md-4">
                            {
                                selectedDocumentType?.additionalValue1 == DocumentTypeYurticiEnum.IRSALIYE && (
                                    <CustomTextInput labelText="YK İrsaliye No" value={despatchNo} setValue={setDespatchNo} isDisabled />
                                )
                            }
                            {
                                selectedDocumentType?.additionalValue1 == DocumentTypeYurticiEnum.KONSIMENTO && (
                                    <CustomTextInput labelText="YK Konşimento No" value={consigmentNo} setValue={setConsigmentNo} isDisabled />
                                )
                            }
                        </div> */}

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Kargo Bölgesi"
                                isLabelRequired
                                selectedValue={selectedShippingRegion}
                                onChange={setSelectedShippingRegion}
                                onMenuOpen={() => ConstantService.getConstantList('SHIPPING_REGION_YURTICI')}
                                labelName='value'
                                valueName="constantId"
                            />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Teslim Tipi"
                                isLabelRequired
                                selectedValue={selectedDeliveringType}
                                onChange={setSelectedDeliveringType}
                                onMenuOpen={() => ConstantService.getConstantList('DELIVERING_TYPE_YURTICI')}
                                labelName='value'
                                valueName="constantId"
                                disabled
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Alım Tipi"
                                isLabelRequired
                                selectedValue={selectedReceivingType}
                                onChange={setSelectedReceivingType}
                                onMenuOpen={() => ConstantService.getConstantList('RECEIVING_TYPE_YURTICI')}
                                labelName='value'
                                valueName="constantId"
                                disabled
                            />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default ShippingAndDocumentInformation;